<template>
  <div class="headerbanner">
    <div class="dummy"></div>
    <router-link to="/" class="picture">
      <svg id="logoacappolli" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 204.6 138.9"><path d="M.9 131.2c-4.2-11.5 6.7-18.7 19.7-20.7 1.6-.4.5.6 2.9-11.8.3-1.3 1-1 3.5-2 .2-.8 0-.8-.4-.9a7.8 7.8 0 01-3-9.5c2.7-9.6 5.1-10.6 3-11.4-9-5.5-13.3-11.4-10.4-22.7.6-.8.8-.5 2-.5l.3-1.2.3-1.2c-1.9-.6-1-3.6.5-3.3 1 0 .8-.6 1.1-1.5.1-.2.2-.9 0-.9-1.8-.6-1.2-3 .4-3 1.2.2 1-.6 1.3-1.5.3-1 .3-1-.1-1-1.9-.8-.6-3.2.7-2.8.6.1.8 0 .8-.7.1-.4.4-1.2.1-1.5-1.9-1.2-1-3.5.5-3.3 1 .1.9 0 1.1-.9.4-1 .4-1.2 0-1.2-1.9-.6-1-3.7.7-3.3.7 0 .7 0 1-.8.3-1.1.3-1.1-.2-1.5-1.8-1.1-.4-3.2.8-3.1 1.2.2.8 0 1.4-1.7-1-.6-1.3-1.3-1.3-2 .3-1.7 1.1-1.6 2.5-1.8.1-.6.8-2 .2-2.1-1-.6-1.2-.8-1-1.4C32.5-.5 47.6-1.2 55.2 1c9.2 5 26.9 10.8 17.7 30-.9.6-1 .9-.5 1.4.7 1.4.4 3.1-.7 3.7-1 .5-1.4 1.2-.9 1.8.2.2.3.6.3 1.4 0 1.1-.4 1.7-1.4 2-.2 0-.4.3-.5.7-.2.6-.2.7.1 1.2.8 1.2.2 3-1 3.3-.5 0-.6.2-.7.8 0 .4 0 .8.2 1.2.7 1.3.3 2.6-.9 3-.6.4-.7.5-.8 1-.1.6 0 .8.2 1.3.8 1.2.1 2.8-1.1 2.8-.3 0-.4.2-.6 1-.3.8-.3.9 0 1.6.7 1 0 2.7-1.2 2.8-.6 0-.6.8-.9 1.3-.2.3-.2.4.2.8 1.3 1.5.2 3-1.5 2.7-.9 2.4-.7 2 .3 2.5.6.3.6.7-.3 2.5-2.4 5-5.3 7-9 8.2-.6.2-.7.3-1.5 1.7-5 10.7-4.8 7.7-5 10.7-.5 4.6-1.8 7-5.5 7.6 1.7 1 1.2-1 1.5 7.6 11.5-1.7 21.1-7.9 26-13.5-17.6-11.1-2.4-21 8.2-14.4 4.2-8.2 11.6-24 13.5-24.4 1 .3.6 27 .6 36.3 1.5 4-.2 3.1 5.9 1.3 5.2-3 4.8-3.3 8-4.7 4.4-1.5 4.8 3.4 3.7 5.3-.5.4-1 .4-2.4 0-5.2-1.6-6.4 8.1-4.3 11.5 5 4.7 8-4.8 9.1-7.6 3.3-6.2 6-8.7 11.7-6.4 3.6-6 4 2.7 2.7 7-2.2 12 2.2 10.1 4.6.3.6-4.8 1.1-6.8 1.8-7.5.8-.9 2.4 0 2.4 1 4.2-5 7-4 9.6.9.8-2.7 2.8-4.3 3.6-1 4.5-5.7 9-1.3 9.7 2.3 4.2-4.6 6.5-4.1 10.6-1.9-4.3-23.5 13-48 16.7-30.3 16-21.6 12.3 30.6 2.5 44.7 4.3 6.5 9.2 1.7 10.5-5.8.3-1.7.2-1.9-.8-2.8.1-5.3-.4-11.3.3-16.3.3-3.2.3-3 2.7-3.4.4-2.4.3-8.6 1-8.8 1-.3 2.3-.3 3 .6 0 3.2-.3 5.7-.3 8.5 2.3.8 2.3.8 2 2.9-2.6 13.5-2.4 18.5-3.9 17.8-.4 0-.6.3-.6 1.1-2.4 15.1-10.5 15-16.2 10-4.7 8.1-13.4 5.2-14.3-4-2 4.9-11 11.1-14.9-3a18 18 0 01-8.5 7.6c-.5.4-1.1 2.2-1.3 4.2-.2 3.8-1.4 11.4-2.1 15.4-.1 1.5-.8 9.2-4.2 6.6-.4-8.6 1.1-16.6 2-26.6.3-2.4.4-5.2.3-5.2-1.5 1.3-3 2.8-4.6 3.8-3.9 2.4-3.9 2.4-4.1 5-2.5 17.8-3 26.7-6.1 23-1.7-2 1.2-19.3 2-27.6l-.3.1c-3.3 4.5-7 1.2-7.1-2.7-3.5 4.8-7.7 2.7-10.2-.1-8 8.3-15.2 2.4-14.2-8.7l-2.3.7c.9 3.8 3.1 13.3 1.5 15-7.4 5.2-8.6-12.2-9-15A48 48 0 0172.2 96a47.4 47.4 0 01-30.2 16.3l.2 3.8c-1.8 1.3-2.5 1.9-3 3.4C36 138.4 7.2 146 1 131.2zm30.6-7c-3.9-3-7.3-4.8-11-7.2.8-3.2.9-2.7-3.3-1.3-28 10.2-.5 30.6 14.3 8.6zM90.2 100c0 3.3 1.3 12 2.5 11.5 1.7-.5-2.1-10.6-2.5-11.5zm90.8 6.8c-3.2-6.2-2.7-12.6-3.4-18.1-1.8 2.6-4.6 4.7-6.6 6.4 0 8.8 4 21.6 10 11.7zm-15-4.5c.3-2.1 0-2.9-1-3.2-2-.4-1.5-2.8-2.8-3.7-4.4-.6-4.3 8.3-2.7 10.9 3.4 4.8 6 .2 6.5-4zM120 96c-4-4.4-7.7 6.3-5.5 8.8 4 2.9 6.6-6.5 5.5-8.8zm26.5 8.3c6.1-1.6 6.3-14.3 1.8-8.2-1.2 1-1.9 3-2.8 7-.4 2.2-.5 2 1 1.2zm-9-9.5c-3.5-1-4.5 6-5.3 9.3 4.2.2 8.7-6.9 5.3-9.3zM189 62c-7.5.8-9 34-5.6 40.3 4.9-7.2 10.1-40 5.6-40.3zM86.2 92.4a49.7 49.7 0 00-8-6.5c-1.5 2.3-2.9 4.5-3.7 6.4 4 1.8 7.8 2.4 11.7 2.5zm84.5-1.7c6.6-4 12.1-23.4 8.4-29.2-6.3-1-10.8 22.2-8.4 29.2zM74 83.6c-11-5.8-13.4 3.8-3.6 6.8.8-.9 3.9-6.3 3.6-6.8zm12.6-16.3c-1 2.4-7.1 14.1-7.4 14.9 2.2 1.3 5.3 3.2 7 4.7l.4-19.6z"/></svg>
    </router-link>
    <div id="greeting">Olá, <span id="namefield">{{ nomeUsuario }}</span>!<button @click="logout">Sair</button></div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'HeaderBanner',
  props: {
    title: String
  },
  computed: {
    nomeUsuario: function () {
      if (firebase.auth().currentUser) return firebase.auth().currentUser.displayName.split(' ')[0]
      else return 'visitante'
    }
  },

  methods: {
    logout: function () {
      const self = this
      firebase.auth().signOut().then(function () {
        self.$router.push({ name: 'login' })
      }).catch(function (error) {
        console.error(error)
      })
    }
  }
}
</script>

<style scoped>

#logoacappolli path {
  fill: white;
}

.headerbanner {
  height: 60px;
  width: 100%;
  background-color: #1d163d;
  display: flex;
  flex-direction: row;
}

  /* Mobile Styles */
@media only screen and (max-width: 415px) {
  .headerbanner {
    background-color: white;
  }
  #logoacappolli path {
    fill: #1d163d;
  }
}

/* iphone XR */
@media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  .headerbanner {
    background-color: white;
  }
  #logoacappolli path {
    fill: #1d163d;
  }
}

/* Desktop Styles */
@media only screen and (min-width: 416px) {
  #logoacappolli path {
    fill: white;
  }
}

#logoacappolli {
  max-height: 60px;
  display: block;
}

.picture {
  flex: 1;
}

.dummy {
  flex: 1;
}

#greeting {
  margin-top: 10px;
  text-align: right;
  flex: 1;
}
</style>
